import React from 'react'

function RuIcon() {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="20" width="18" height="6" fill="white" />
      <rect x="8" y="20" width="18" height="6" fill="#FF1901" />
      <rect x="8" y="8" width="18" height="6" fill="white" />
      <rect x="8" y="14" width="18" height="6" fill="white" />
      <rect x="8" y="14" width="18" height="6" fill="#417CFF" />
    </svg>
  )
}

export default RuIcon
